<template lang="pug">
section
    h4(v-if='mostrarTitulo', :class='getTitleClass()') {{ $t('mensagens.territorio.territorioAr.persona.titulo') }}

    div(:class='classCard()')
        .form-section
            el-form(
                label-position='top',
                :model='form',
                :rules='rules',
                ref='ruleForm'
            )
                el-row(
                    align='bottom',
                    justify='space-between',
                    type='flex',
                    :gutter='20'
                )
                    el-col(:span='11')
                        el-form-item(
                            style='width: 100%',
                            prop='pessoa',
                            :label='$t("mensagens.territorio.territorioAr.persona.persona")'
                        )
                            el-select(
                                style='width: 100%',
                                :placeholder='$t("mensagens.territorio.territorioAr.persona.personaPlaceholder")',
                                v-model='form.pessoa',
                                filterable
                                :loading='loading'
                            )
                                el-option(
                                    :value='item.id',
                                    :label='item.nomeRazaoSocial',
                                    :key='item.id',
                                    value-key='id',
                                    v-for='(item, index) in representantes'
                                )
                    el-col(:span='11')
                        el-form-item(
                            prop='papel',
                            :label='$t("mensagens.territorio.territorioAr.persona.papel")'
                        )
                            el-select(
                                style='width: 100%',
                                :placeholder='$t("mensagens.territorio.territorioAr.persona.papelPlaceholder")',
                                v-model='form.papel',
                                filterable
                            )
                                el-option(
                                    :value='item.id',
                                    :label='item.nome',
                                    :key='item.id',
                                    value-key='id',
                                    v-for='(item, index) in papeis'
                                )
                    el-col(:span='2')
                        .btn-add-wrapper
                            el-button.btn-add(
                                @click='addInformation("ruleForm")',
                                type='primary',
                                icon='el-icon-plus',
                                circle
                            )

        el-divider(v-if='options.length > 0')
        
        .lista-pessoas(v-if='options.length > 0')
            .pessoa-card(
                v-for='(item, index) in options',
                :key='index'
            )
                .pessoa-info
                    .info-block
                        .info-label {{ $t('mensagens.territorio.territorioAr.persona.persona') }}
                        .info-value {{ item.pessoa.nome }}
                    .info-block
                        .info-label CUIT
                        .info-value {{ formatCuit(item.pessoa?.documento) }}
                    .info-block
                        .info-label {{ $t('mensagens.territorio.territorioAr.persona.papel') }}
                        .info-value {{ item.papel?.nome }}
                .pessoa-actions
                    el-button(
                        @click='deleteInformation(index)',
                        type='text',
                        icon='el-icon-delete',
                        class='btn-delete'
                    )
        
        .empty-state(v-else)
            i.el-icon-user-solid.empty-icon
            p.empty-text {{ $t('mensagens.territorio.territorioAr.persona.mensagem') }}
</template>
<script>
import formatters from '@/utils/formatters';
import { mapState } from 'vuex';

export default {
    data() {
        return {
            form: { pessoa: null, papel: null },
            rules: {
                pessoa: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                papel: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    props: {
        representantes: {
            type: Array
        },
        papeis: {
            type: Array
        },
        options: {
            type: Array
        },
        loading: {
            required: false,
            type: Boolean,
            default: false
        },
        mostrarTitulo: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    methods: {
        addInformation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const params = {
                        pessoa: {
                            nome: this.representantes.find(
                                item => item.id === this.form.pessoa
                            ).nomeRazaoSocial,
                            documento: this.representantes.find(
                                item => item.id === this.form.pessoa
                            ).documento,
                            id: this.form.pessoa
                        },
                        papel: {
                            nome: this.papeis.find(
                                item => item.id === this.form.papel
                            ).nome,
                            id: this.form.papel
                        }
                    };

                    this.$emit('update', params);
                    this.$refs[formName].resetFields();
                } else {
                    return false;
                }
            });
        },
        getTitleClass() {
            return this.usuarioLogado.ambienteLogado === 'PY'
                ? 'titulo-py'
                : 'titulo-ar';
        },
        classCard() {
            return this.usuarioLogado.ambienteLogado === 'AR'
                ? 'card-component'
                : '';
        },
        deleteInformation(index) {
            this.$emit('delete', index);
        },
        formatCuit(documento) {
            return formatters.formatarCuit(documento);
        }
    }
};
</script>
<style scoped lang="scss">
.titulo-py {
    font-size: 14px;
    font-weight: 700;
    color: dimgray;
    padding-top: 10px;
    padding-bottom: 10px;
}

.titulo-ar {
    font-weight: 700;
    color: #5a5a5a;
    margin-bottom: 16px;
}

.card-component {
    padding: 24px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    min-height: 345px;
}

.form-section {
    margin-bottom: 12px;
}

.btn-add-wrapper {
    display: flex;
    align-items: flex-end;
    height: 100%;
    padding-bottom: 8px;
}

.btn-add {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px !important;
    
    &:hover {
        transform: scale(1.05);
        transition: transform 0.2s ease;
    }
}

.lista-pessoas {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.pessoa-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 16px 20px;
    transition: all 0.3s ease;
    
    &:hover {
        background: #f0f2f5;
        border-color: #b3d8ff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
}

.pessoa-info {
    display: flex;
    gap: 1rem;
    flex: 1;
}

.info-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 180px;
}

.info-label {
    font-size: 12px;
    font-weight: 600;
    color: #606266;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-value {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    word-break: break-word;
}

.pessoa-actions {
    display: flex;
    align-items: center;
}

.btn-delete {
    color: #f56c6c;
    font-size: 20px;
    padding: 8px;
    
    &:hover {
        color: #dc362e;
        background: rgba(245, 108, 108, 0.1);
        border-radius: 4px;
    }
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    text-align: center;
}

.empty-icon {
    font-size: 64px;
    color: #c0c4cc;
    margin-bottom: 16px;
}

.empty-text {
    font-size: 14px;
    color: #909399;
    margin: 0;
    font-weight: 500;
}

// Melhorias nos selects
::v-deep .el-select {
    .el-input__inner {
        border-radius: 6px;
        transition: all 0.3s ease;
        
        &:hover {
            border-color: #b3d8ff;
        }
        
        &:focus {
            border-color: #409eff;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
    }
}

::v-deep .el-form-item__label {
    font-weight: 600;
    color: #5a5a5a;
    margin-bottom: 8px;
}
</style>
